import { axiosInstance } from "@/api/apiClient";
import {
  UsersApi,
  UsersApiUsersViewsNinjaUsersGetInvitationsRequest,
  UsersApiUsersViewsNinjaUsersGetNotificationsRequest,
  UsersApiUsersViewsNinjaUsersGetUserBusinessRequest,
  UsersApiUsersViewsNinjaUsersListDemoVideosRequest,
  UsersApiUsersViewsNinjaUsersUpdateUserRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new UsersApi(undefined, BASE_API, axiosInstance);

export const getUser = async () => {
  return api.usersViewsNinjaUsersGetUser.bind(api)();
};

export const getDemoVideos = async (
  payload: UsersApiUsersViewsNinjaUsersListDemoVideosRequest = {}
) => {
  return api.usersViewsNinjaUsersListDemoVideos.bind(api)(payload);
};

export const updateUser = async (
  payload: UsersApiUsersViewsNinjaUsersUpdateUserRequest
) => {
  return api.usersViewsNinjaUsersUpdateUser.bind(api)(payload);
};

export const getUserBusiness = async (
  payload: UsersApiUsersViewsNinjaUsersGetUserBusinessRequest = {}
) => {
  return api.usersViewsNinjaUsersGetUserBusiness.bind(api)(payload);
};

export const getUserV2 = async () => {
  return api.usersViewsNinjaUsersGetUserV2.bind(api)();
};

export const getFreeTrialData = async () => {
  return api.usersViewsNinjaUsersGetFreeTrialData.bind(api)();
};

export const getPersonalChannelToken = async () => {
  return api.usersViewsNinjaUsersGetPersonalChannelToken.bind(api)();
};

export const getNotifications = async (
  payload: UsersApiUsersViewsNinjaUsersGetNotificationsRequest = {}
) => {
  return api.usersViewsNinjaUsersGetNotifications.bind(api)(payload);
};

export const getInvitations = async (
  payload: UsersApiUsersViewsNinjaUsersGetInvitationsRequest = {}
) => {
  return api.usersViewsNinjaUsersGetInvitations.bind(api)(payload);
};
